export const VARIANT_HORIZONTAL = 'horizontal';
export const VARIANT_VERTICAL = 'vertical';
export const CATEGORY_RATING = 'rating';
export const CATEGORY_NEUTRAL = 'neutral';